import { render } from "./post-by-tag.vue?vue&type=template&id=571d954c&scoped=true"
import script from "./post-by-tag.vue?vue&type=script&lang=js"
export * from "./post-by-tag.vue?vue&type=script&lang=js"

import "./post-by-tag.vue?vue&type=style&index=0&id=571d954c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571d954c"]])

export default __exports__